angular.module( 'acme.view.application.partners.list.categories', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.partners.list.categories.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersListCategories = {
        name: 'application.partners.list.categories',
        url: '/categories',
        views: {
          "subview-main": {
            controller: 'PartnersListCategoriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/list/categories/categories.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Categories',
          permissions: ['ACCT_CATEGORIES_VIEW'],
          enablePreferences: true
        }
      };

    $stateProvider
      .state(partnersListCategories);
});
